import { render, staticRenderFns } from "./Jurnalrequest.vue?vue&type=template&id=32f1bcde"
import script from "./Jurnalrequest.vue?vue&type=script&lang=js"
export * from "./Jurnalrequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports